import { fetcher } from '@commenda/utils';

import { UpdateBillingQuoteIntervalParams } from './types';

export const updateBillingQuoteInterval = ({
  quoteId,
  defaultBillingInterval,
  expectedEditVersion,
}: UpdateBillingQuoteIntervalParams) =>
  fetcher(`commenda-billing/quotes/${quoteId}/billing-interval`, {
    method: 'PATCH',
    body: { defaultBillingInterval, expectedEditVersion },
  });
